"use client";

import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import { useLenisInstance } from './LenisProvider';

export default function ScrollToHashHandler() {
  const lenis = useLenisInstance();
  const searchParams = useSearchParams();

  useEffect(() => {
    const scrollToSection = searchParams.get('scrollTo');
    
    if (scrollToSection) {
      // Function to wait for element and perform scroll
      const waitAndScroll = () => {
        const element = document.getElementById(scrollToSection);
        
        if (!element) {
          // Element not found, try again after a short delay
          setTimeout(waitAndScroll, 100);
          return;
        }

        // Element found, wait for page to fully load and stabilize
        const performScroll = () => {
          // Double-check element still exists
          const targetElement = document.getElementById(scrollToSection);
          if (!targetElement) return;

          if (scrollToSection === 'email-form') {
            // Special handling for email form
            if (lenis) {
              lenis.scrollTo(targetElement, { 
                offset: -600,
                duration: 1.2,
                onComplete: () => {
                  // Add glow effect after scroll completes
                  setTimeout(() => {
                    targetElement.style.boxShadow = "0 0 20px rgba(236, 194, 74, 0.8)";
                    targetElement.style.transition = "box-shadow 0.3s ease";
                    setTimeout(() => {
                      targetElement.style.boxShadow = "none";
                    }, 1000);
                  }, 100);
                }
              });
            } else {
              // Fallback without lenis
              const rect = targetElement.getBoundingClientRect();
              const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
              const targetY = rect.top + scrollTop - 600;
              
              window.scrollTo({ 
                top: Math.max(0, targetY), 
                behavior: 'smooth' 
              });
              
              setTimeout(() => {
                targetElement.style.boxShadow = "0 0 20px rgba(236, 194, 74, 0.8)";
                targetElement.style.transition = "box-shadow 0.3s ease";
                setTimeout(() => {
                  targetElement.style.boxShadow = "none";
                }, 1000);
              }, 1200);
            }
          } else {
            // Regular sections
            if (lenis) {
              lenis.scrollTo(targetElement, { 
                offset: -80,
                duration: 1.2
              });
            } else {
              // Fallback without lenis
              const rect = targetElement.getBoundingClientRect();
              const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
              const targetY = rect.top + scrollTop - 80;
              
              window.scrollTo({ 
                top: Math.max(0, targetY), 
                behavior: 'smooth' 
              });
            }
          }
        };

        // Wait for everything to load and settle
        if (document.readyState === 'complete') {
          // Page already loaded, wait for layout to stabilize
          setTimeout(performScroll, 1000);
        } else {
          // Wait for page load
          window.addEventListener('load', () => {
            setTimeout(performScroll, 1000);
          }, { once: true });
        }
      };

      // Start the process
      waitAndScroll();
    }
  }, [searchParams, lenis]);

  return null;
}
